import { Box, Button, styled } from '@mui/material';
import { getBasicActionStyling } from '../../Popover.utils';

export const PopoverActionButton = styled(Button)(({ theme }) => ({
  ...getBasicActionStyling(theme),
  '&:disabled': {
    backgroundColor: theme.vars.palette.surface.container,
    '& svg': {
      opacity: 0.5
    }
  }
}));

export const IconWrapper = styled(Box)({
  width: '16px'
});

export const DisplayWrapper = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  justifyContent: 'flex-start',
  paddingRight: theme.spacing(5)
}));

export const TailWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end'
});
